import { fetchClientSummaries } from '../../services/clients';
import { fetchDealActivitiesByNature } from '../../services/dealActivities';
import { fetchDealLines } from '../../services/dealLines';
import { fetchDeals } from '../../services/deals';

// Prochaine action de chaque affaire : date la plus proche (les sans-date passent après).
export function nextActionByDeal(activities) {
  const next = {};
  for (const a of activities) {
    const cur = next[a.affaire_id];
    const better = !cur || (a.date && (!cur.date || a.date < cur.date));
    if (better) next[a.affaire_id] = { type: a.type, date: a.date };
  }
  return next;
}

/* CRM : chargement des affaires (avec leurs lignes), des clients et des prochaines actions. */
export default function dealsLoadingHandlers(deps) {
  const { setDealsLoaded, setDealNextActions, setDealTasks, setDeals, setCrmClients } = deps;

  async function loadDeals() {
    const [{ data: aff }, { data: cli }, { data: act }, { data: lig }] = await Promise.all([
      fetchDeals(),
      fetchClientSummaries(),
      fetchDealActivitiesByNature(),
      fetchDealLines(),
    ]);
    const linesByDeal = {};
    for (const l of lig || []) (linesByDeal[l.affaire_id] ||= []).push(l);
    const deals = (aff || []).map((a) => ({ ...a, lignes: linesByDeal[a.id] || [] }));
    setDeals(deals);
    setCrmClients(cli || []);
    setDealNextActions(nextActionByDeal(act || []));
    setDealTasks(act || []);
    setDealsLoaded(true);
    return deals;
  }

  return { loadDeals };
}
